import { TrashCan } from '@carbon/icons-react';
import { IconButton, IconButtonProps } from '@carbon/react';
import { MouseEvent, ReactNode } from 'react';

type Props = {
    onClick?: (evt: MouseEvent) => void;
    label: string;
    size?: IconButtonProps['size'];
    iconSize?: number;
    kind?: IconButtonProps['kind'];
    align?: IconButtonProps['align'];
    disabled?: boolean;
    icon?: ReactNode;
    className?: string;
}

const CommonButton = ({
    onClick,
    label,
    size = 'lg',
    kind = 'primary',
    iconSize = 16,
    align = 'top',
    disabled,
    icon = <TrashCan size={iconSize} />,
    className,
}: Props) => (
    <IconButton
        label={label}
        size={size}
        align={align}
        disabled={disabled}
        onClick={onClick}
        kind={kind}
        className={className}
    >
        {icon}
    </IconButton>
);

export default CommonButton;
